import TranslationsProvider from './TranslationsProvider/TranslationsProvider';
import { useTranslation, withTranslation } from './i18n.consumers';
import { LocalizedRoutes, LocalizedLink, LocalizedNavLink } from './i18n.router';
import { i18n } from './i18n.context';

export {
  withTranslation,
  useTranslation,
  i18n,
  LocalizedRoutes,
  LocalizedLink,
  LocalizedNavLink,
};

export default TranslationsProvider;
